export default __webpack_public_path__ + "static/jetson_safety_background_mobile-4b0dfd297a7e7ebdeec6b7418d696a1c.png";